export default __webpack_public_path__ + "static/clean-ingredients_experts_Jarred-V-8e3cebc3ff665b12fa3e190cb48dc760.png";